/* GNT Welcome Kit Card — Phase 1 v3 (robust variant detection) */
(function () {
  'use strict';

  function moneyAUD(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  function detectTier(variantTitle, card) {
    var t = (variantTitle || '').toLowerCase();
    if (t.indexOf((card.dataset.tier12moMatch || '12 month').toLowerCase()) !== -1) return '12mo';
    if (t.indexOf((card.dataset.tier6moMatch || '6 month').toLowerCase()) !== -1) return '6mo';
    if (t.indexOf((card.dataset.tier3moMatch || '3 month').toLowerCase()) !== -1) return '3mo';
    if (t.indexOf((card.dataset.tier1moMatch || '1 month').toLowerCase()) !== -1) return '1mo';
    return '1mo';
  }

  function tierLabel(tier) {
    if (tier === '12mo') return '12 month supply';
    if (tier === '6mo') return '6 month supply';
    if (tier === '3mo') return '3 month supply';
    return '1 month supply';
  }
  function deliveryPhrase(tier) {
    if (tier === '6mo') return 'Deliver every 6 months';
    if (tier === '3mo') return 'Deliver every 3 months';
    return 'Deliver every 1 month';
  }
  function monthsForTier(tier) {
    if (tier === '12mo') return 12;
    if (tier === '6mo') return 6;
    if (tier === '3mo') return 3;
    return 1;
  }

  function findVariant(card, variantId) {
    var dataNode = card.querySelector('[data-gnt-wk-variants]');
    if (!dataNode) return null;
    var variants;
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (e) {
      return null;
    }
    if (variantId) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === variantId) return variants[i];
      }
    }
    return variants[0] || null;
  }

  function findVariantByTitle(card, title) {
    var dataNode = card.querySelector('[data-gnt-wk-variants]');
    if (!dataNode || !title) return null;
    var variants;
    try { variants = JSON.parse(dataNode.textContent); } catch (e) { return null; }
    var needle = (title || '').toLowerCase().trim();
    for (var i = 0; i < variants.length; i++) {
      var vt = (variants[i].title || '').toLowerCase().trim();
      if (vt === needle || vt.indexOf(needle) !== -1 || needle.indexOf(vt) !== -1) return variants[i];
    }
    return null;
  }

  function activeVariantId() {
    var match = window.location.search.match(/[?&]variant=(\d+)/);
    if (match) return parseInt(match[1], 10);
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && idInput.value) return parseInt(idInput.value, 10);
    return null;
  }

  // Read variant from checked option radios (Shopify variant pickers)
  function variantFromCheckedRadios(card) {
    var radios = document.querySelectorAll('input[type="radio"]:checked');
    var values = [];
    radios.forEach(function (r) {
      var n = r.name || '';
      if (n.indexOf('options[') !== -1 || n.indexOf('Section-') !== -1 || r.dataset.singleOptionSelector !== undefined) {
        if (r.value) values.push(r.value.toLowerCase().trim());
      }
    });
    if (!values.length) return null;
    var dataNode = card.querySelector('[data-gnt-wk-variants]');
    if (!dataNode) return null;
    var variants;
    try { variants = JSON.parse(dataNode.textContent); } catch (e) { return null; }
    for (var i = 0; i < variants.length; i++) {
      var vt = (variants[i].title || '').toLowerCase();
      var allMatch = true;
      for (var j = 0; j < values.length; j++) {
        if (vt.indexOf(values[j]) === -1) { allMatch = false; break; }
      }
      if (allMatch) return variants[i];
    }
    return null;
  }

  function setText(el, text) { if (el) el.textContent = text; }
  function setDisplay(el, show) { if (el) el.style.display = show ? '' : 'none'; }

  function updateCard(card, variant) {
    if (!variant) return;
    var tier = detectTier(variant.title, card);

    card.classList.toggle('is-12mo', tier === '12mo');

    card.querySelectorAll('[data-gnt-wk-tier]').forEach(function (li) {
      li.classList.toggle('is-active', li.dataset.gntWkTier === tier);
      li.classList.remove('is-first-active');
    });
    var firstActive = card.querySelector('[data-gnt-wk-tier].is-active');
    if (firstActive) firstActive.classList.add('is-first-active');

    var subAlloc = (variant.selling_plan_allocations || [])[0];
    var subPrice = subAlloc ? subAlloc.price : variant.price;
    var subCompare = (variant.compare_at_price && variant.compare_at_price > variant.price)
      ? variant.compare_at_price
      : variant.price;
    var subSavings = subCompare - subPrice;
    var subPct = subCompare > 0 ? Math.round((subSavings / subCompare) * 100) : 0;

    // Per-month display (IM8 style)
    var monthsPerCycle = monthsForTier(tier);
    var perMonthSub = subPrice / monthsPerCycle;
    var perMonthCompare = subCompare / monthsPerCycle;

    setText(card.querySelector('[data-gnt-wk-sub-title]'), tierLabel(tier));

    function writePrice(el, cents, suffix) {
      if (!el) return;
      el.textContent = '';
      el.appendChild(document.createTextNode(moneyAUD(cents)));
      if (suffix) {
        var sfx = document.createElement('span');
        sfx.className = 'gnt-wk-option__price-suffix';
        sfx.textContent = suffix;
        el.appendChild(sfx);
      }
    }

    var elSubCompare = card.querySelector('[data-gnt-wk-compare-price]');
    // Strike = FULL price (per cycle), no /mo suffix
    writePrice(elSubCompare, subCompare, null);
    setDisplay(elSubCompare, subCompare > subPrice);

    // Sale = per-month with /mo
    writePrice(card.querySelector('[data-gnt-wk-sale-price]'), perMonthSub, '/mo');

    var elSubSavings = card.querySelector('[data-gnt-wk-savings]');
    setText(elSubSavings, 'SAVE ' + moneyAUD(subSavings));
    setDisplay(elSubSavings, subSavings > 0);

    var elBadge = card.querySelector('[data-gnt-wk-discount-badge]');
    setText(elBadge, subPct > 0 ? subPct + '% OFF' : '');
    setDisplay(elBadge, subPct > 0);

    setText(card.querySelector('[data-gnt-wk-footer]'),
      deliveryPhrase(tier) + '. Skip, pause or cancel anytime.');

    var onceCompare = (variant.compare_at_price && variant.compare_at_price > variant.price)
      ? variant.compare_at_price
      : variant.price;
    var onceSavings = onceCompare - variant.price;

    setText(card.querySelector('[data-gnt-wk-once-title]'), tier === '12mo' ? tierLabel(tier) : 'Buy Once');

    var elOnceCompare = card.querySelector('[data-gnt-wk-once-compare]');
    setText(elOnceCompare, moneyAUD(onceCompare));
    setDisplay(elOnceCompare, onceCompare > variant.price);

    setText(card.querySelector('[data-gnt-wk-once-price]'), moneyAUD(variant.price));

    var elOnceSavings = card.querySelector('[data-gnt-wk-once-savings]');
    setText(elOnceSavings, 'SAVE ' + moneyAUD(onceSavings));
    setDisplay(elOnceSavings, onceSavings > 0);

    if (tier === '12mo') {
      var onceRadio = card.querySelector('[data-gnt-wk-radio="once"]');
      if (onceRadio) onceRadio.checked = true;
    }

    // Stash current state on the card for the cart submit handler
    card.dataset.currentTier = tier;
    card.dataset.currentVariantId = variant.id;
    card.dataset.currentSellingPlanId = subAlloc ? subAlloc.selling_plan_id : '';

    updateAddToCartButton(card, variant);
  }

  // Cache: latest desired price string per card so observers can re-apply on Alpine writes
  var __gntWkLatestPrice = '';
  var __gntWkObserverBound = false;
  var __gntWkWriting = false;

  function computePrices(card) {
    var vid = parseInt(card.dataset.currentVariantId || '0', 10);
    var variant = findVariant(card, vid);
    if (!variant) return null;
    var modeRadio = card.querySelector('input[name="gnt-wk-mode"]:checked');
    var mode = modeRadio ? modeRadio.value : 'subscribe';
    var subAlloc = (variant.selling_plan_allocations || [])[0];
    var price = (mode === 'subscribe' && subAlloc) ? subAlloc.price : variant.price;
    var compare = 0;
    // Only inject a strikethrough when the theme isn't already showing one.
    // Theme shows strike when variant.compare_at_price > variant.price (3mo/6mo case).
    // For 1mo, compare_at_price == price (or null), so theme doesn't strike — we inject one for sub mode.
    var themeShowsStrike = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
    if (mode === 'subscribe' && subAlloc && variant.price > subAlloc.price && !themeShowsStrike) {
      compare = variant.price;
    }
    return { price: moneyAUD(price), compare: compare > 0 ? moneyAUD(compare) : '' };
  }

  function writeButtonPrice(card) {
    if (__gntWkWriting) return;
    var prices = computePrices(card);
    if (!prices) return;
    __gntWkLatestPrice = prices.price;

    __gntWkWriting = true;
    var priceEls = document.querySelectorAll(
      'form[action*="/cart/add"] [x-html*="current_price"], ' +
      'form[action*="/cart/add"] [data-current-price]'
    );
    priceEls.forEach(function (el) {
      if (el.innerHTML !== prices.price) el.innerHTML = prices.price;

      // Inject a strikethrough sibling for the sub-only compare price
      var parent = el.parentElement;
      if (!parent) return;
      var compareEl = parent.querySelector('.gnt-wk-btn-compare');
      if (prices.compare) {
        if (!compareEl) {
          compareEl = document.createElement('s');
          compareEl.className = 'gnt-wk-btn-compare';
          compareEl.style.cssText = 'opacity:0.55; margin-left:0.4em; font-weight:400;';
          el.insertAdjacentElement('afterend', compareEl);
        }
        if (compareEl.textContent !== prices.compare) compareEl.textContent = prices.compare;
        compareEl.style.display = '';
      } else if (compareEl) {
        compareEl.style.display = 'none';
      }
    });
    setTimeout(function () { __gntWkWriting = false; }, 20);
  }

  function bindPriceObserver(card) {
    if (__gntWkObserverBound) return;
    var priceEls = document.querySelectorAll(
      'form[action*="/cart/add"] [x-html*="current_price"], ' +
      'form[action*="/cart/add"] [data-current-price]'
    );
    if (!priceEls.length) return;
    __gntWkObserverBound = true;

    var observer = new MutationObserver(function () {
      if (__gntWkWriting) return;
      // Alpine just wrote something — slap our value back in
      writeButtonPrice(card);
    });

    priceEls.forEach(function (el) {
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function updateAddToCartButton(card, variant) {
    if (!variant) return;
    bindPriceObserver(card);
    writeButtonPrice(card);
    setTimeout(function () { writeButtonPrice(card); }, 0);
    setTimeout(function () { writeButtonPrice(card); }, 100);
    setTimeout(function () { writeButtonPrice(card); }, 300);
  }

  function looksLikeCheckoutTarget(el) {
    if (!el || el.nodeType !== 1) return false;
    // 1) Anchor tags that go to checkout
    if (el.tagName === 'A') {
      var href = (el.getAttribute('href') || '').toLowerCase();
      if (href === '/checkout' || href.indexOf('/checkout?') === 0 || href.indexOf('/checkouts/') !== -1) return true;
    }
    // 2) Form submit / button[name=checkout]
    if (el.tagName === 'BUTTON' || el.tagName === 'INPUT') {
      var name = (el.getAttribute('name') || '').toLowerCase();
      if (name === 'checkout' || name === 'goto-checkout') return true;
    }
    // 3) Text content "checkout" (catches Corner Cart's custom button + most themes)
    var t = (el.textContent || '').trim().toLowerCase();
    if (/^checkout\b|\bcheckout\s*[–\-]\s*\$/.test(t) && t.length < 60) return true;
    // 4) Common class hints
    var cls = (el.className || '') + '';
    if (typeof cls === 'string' && /(checkout-button|cart-checkout|cart__checkout|corner.*checkout|cc-checkout)/i.test(cls)) return true;
    return false;
  }

  function bindCheckoutIntercept() {
    // No-op now — Shopify Discount Function applies gift discounts server-side
    // automatically at checkout. No JS-side discount hijack needed.
  }

  // Continuously sync a hidden selling_plan input on the cart form.
  // This is a SAFETY NET — even if our click intercept fails or is bypassed,
  // the theme's native cart-add flow will pick up this input and carry the
  // correct selling_plan along with the variant id.
  function syncSellingPlanInput(card) {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    if (!forms.length) return;

    var modeRadio = card.querySelector('input[name="gnt-wk-mode"]:checked');
    var mode = modeRadio ? modeRadio.value : 'subscribe';

    var planValue = '';
    if (mode === 'subscribe') {
      var variant = variantFromCheckedRadios(card);
      if (!variant) {
        var vid = activeVariantId();
        if (vid) variant = findVariant(card, vid);
      }
      if (!variant) {
        var dataNode = card.querySelector('[data-gnt-wk-variants]');
        if (dataNode) {
          try { variant = (JSON.parse(dataNode.textContent) || [])[0]; } catch (e) {}
        }
      }
      if (variant) {
        var tier = detectTier(variant.title, card);
        planValue = card.getAttribute('data-plan-' + tier) || '';
        if (!planValue) {
          var spa = (variant.selling_plan_allocations || [])[0];
          if (spa && spa.selling_plan_id) planValue = String(spa.selling_plan_id);
        }
      }
    }

    // Only sync the form whose product matches THIS card (or any form with no handle attribute as a fallback)
    var cardHandle = card.getAttribute('data-product-handle') || '';
    forms.forEach(function (form) {
      var formHandle = form.getAttribute('data-product-handle') || '';
      if (formHandle && cardHandle && formHandle !== cardHandle) return;

      var input = form.querySelector('input[name="selling_plan"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
      }
      input.value = planValue;

      // Also sync the theme's existing typo'd selling_plann input if it exists
      var typoInput = form.querySelector('input[name="selling_plann"]');
      if (typoInput) typoInput.value = planValue;
    });
  }

  function bindAddToCartIntercept(card) {
    // Click-based intercept — runs BEFORE the theme's Alpine handler.
    // Uses document-level capture so it fires regardless of how the button is wired.
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest(
        'form[action*="/cart/add"] button[type="submit"], ' +
        'form[action*="/cart/add"] [type="submit"], ' +
        'form[action*="/cart/add"] [name="add"]'
      );
      if (!btn) return;

      var form = btn.closest('form[action*="/cart/add"]');
      if (!form) return;

      // Only handle clicks for the form whose product matches THIS card.
      // The PDP may render multiple cards (main product + featured related product),
      // each one binds a doc-level click listener. Without this guard, both fire
      // for every Add to Cart click and the wrong one wins.
      var formHandle = form.getAttribute('data-product-handle') || '';
      var cardHandle = card.getAttribute('data-product-handle') || '';
      if (formHandle && cardHandle && formHandle !== cardHandle) return;

      var modeRadio = card.querySelector('input[name="gnt-wk-mode"]:checked');
      var mode = modeRadio ? modeRadio.value : 'subscribe';

      // Resolve the current variant FRESH every click — don't trust stale dataset.
      // Priority: variant tile checked radio > URL ?variant= > form id input > JSON first
      var variant = variantFromCheckedRadios(card);
      if (!variant) {
        var vid = activeVariantId();
        if (vid) variant = findVariant(card, vid);
      }
      if (!variant) {
        var dataNode = card.querySelector('[data-gnt-wk-variants]');
        if (dataNode) {
          try { variant = (JSON.parse(dataNode.textContent) || [])[0]; } catch (e2) {}
        }
      }
      if (!variant) return; // can't proceed without variant

      var mainId = variant.id;
      var tier = detectTier(variant.title, card);

      // NOTE: gifts are NOT added here. The fetch interceptor is the single source of
      // truth for adding gifts — it checks cart state to avoid duplicates. The click
      // intercept just builds the main item; the interceptor injects gifts.
      var giftIds = [];

      // ALWAYS take over so we control selling_plan precisely (Seal injects its own input)
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      var quantity = 1;
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput && qtyInput.value) quantity = parseInt(qtyInput.value, 10) || 1;

      // For Subscribe mode, attach selling plan; for Buy Once, no plan.
      // Use getAttribute() instead of dataset to bypass HTML5 camelCase rules that don't
      // convert dash-before-digit (data-plan-1mo doesn't map to dataset.plan1mo).
      var sellingPlan = null;
      if (mode === 'subscribe') {
        // Prefer the SELECTED variant's own selling plan (correct for Original AND Vented).
        var subAlloc = (variant.selling_plan_allocations || [])[0];
        if (subAlloc && subAlloc.selling_plan_id) {
          sellingPlan = parseInt(subAlloc.selling_plan_id, 10) || null;
        }
        if (!sellingPlan) {
          var planFromAttr = card.getAttribute('data-plan-' + tier);
          if (planFromAttr) sellingPlan = parseInt(planFromAttr, 10) || null;
        }
      }

      // IMPORTANT: do NOT override mainId with data-variant-<tier>. That slot collapses to
      // one variant per tier (last-wins = Vented on the 2-option collagen product) and would
      // force the wrong variant into the cart. Trust the variant resolved from checked options.

      var mainItem = { id: mainId, quantity: quantity };
      if (sellingPlan) mainItem.selling_plan = sellingPlan;

      var items = [mainItem];
      giftIds.forEach(function (gid) {
        items.push({
          id: parseInt(gid, 10),
          quantity: 1,
          properties: { _wk_gift: 'yes' }
        });
      });

      setButtonAdding(btn, true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add returned ' + r.status);
        return r.json();
      })
      .then(function (data) {
        setButtonAdding(btn, false);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
        // Corner Cart official SDK
        if (window.corner && typeof window.corner.do === 'function') {
          window.corner.do('openCart');
          return;
        }
        // Generic fallbacks
        var trig = document.querySelector('[data-cart-drawer-trigger], [data-cart-toggle], .js-cart-drawer-open, [href="#cart-drawer"]');
        if (trig) { trig.click(); return; }
        window.location.href = '/cart';
      })
      .catch(function (err) {
        setButtonAdding(btn, false);
        console.error('[gnt-wk] cart add failed, going to /cart', err);
        window.location.href = '/cart';
      });
    }, true); // capture phase
  }

  function setButtonAdding(btn, isAdding) {
    if (!btn) return;
    if (isAdding) {
      btn.classList.add('gnt-wk-adding');
      btn.disabled = true;
    } else {
      btn.classList.remove('gnt-wk-adding');
      btn.disabled = false;
    }
  }

  function initCard(card) {
    var refresh = function (variantHint) {
      var v = null;
      if (variantHint && variantHint.id) {
        v = findVariant(card, variantHint.id) || variantHint;
      } else if (variantHint && variantHint.title) {
        v = findVariantByTitle(card, variantHint.title);
      }
      // Try reading from currently-checked option radios FIRST (most reliable on themes that use Alpine)
      if (!v) {
        v = variantFromCheckedRadios(card);
      }
      // Then URL / hidden form id
      if (!v) {
        var vid = activeVariantId();
        v = findVariant(card, vid);
      }
      updateCard(card, v);
    };

    refresh();

    // 1) Theme's custom event (if it fires)
    document.addEventListener('shapes:product:variantchange', function (e) {
      var v = e && e.detail && e.detail.variant;
      refresh(v || null);
    });

    // 2) Generic product variant change event (fallback)
    document.addEventListener('product:variant-change', function (e) {
      var v = e && e.detail && (e.detail.variant || e.detail);
      refresh(v || null);
    });
    document.addEventListener('variant:change', function (e) {
      var v = e && e.detail && (e.detail.variant || e.detail);
      refresh(v || null);
    });

    // 3) Click handler on variant tiles
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.variant-card');
      var input = e.target.closest && e.target.closest('.variant-input');
      if (card || input) {
        // Try to get variant id from data attr or input value
        setTimeout(refresh, 50);
        setTimeout(refresh, 250);
        setTimeout(refresh, 600);
      }
    }, true);

    // 4) Change handler on any radio with "options[" in name (Shopify variant pickers)
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.tagName !== 'INPUT') return;
      var n = t.name || '';
      if (n.indexOf('options[') !== -1 || n.indexOf('Section-') !== -1 || t.dataset.singleOptionSelector !== undefined) {
        setTimeout(refresh, 30);
        setTimeout(refresh, 200);
        setTimeout(refresh, 500);
      }
    }, true);

    // 5) URL change
    window.addEventListener('popstate', function () { refresh(); });

    // 6) Mutation observer on the hidden form id input
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) {
        var mo = new MutationObserver(function () { refresh(); });
        mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    // 7) Belt-and-suspenders: poll every 800ms in case the theme uses some bespoke mechanism
    var lastId = null;
    setInterval(function () {
      var vid = activeVariantId();
      if (vid !== lastId) {
        lastId = vid;
        refresh();
      }
    }, 800);

    // When user toggles Subscribe ↔ Buy Once, re-render the button price + sync form input
    card.querySelectorAll('input[name="gnt-wk-mode"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var vid = parseInt(card.dataset.currentVariantId || '0', 10);
        var v = findVariant(card, vid);
        updateAddToCartButton(card, v);
        syncSellingPlanInput(card);
      });
    });

    // Sync form input on init + whenever variant changes (refresh triggers updateCard which triggers this via interval)
    syncSellingPlanInput(card);
    setInterval(function () { syncSellingPlanInput(card); }, 500); // safety net polling

    // Bind the cart submit intercept (handles selling_plan + gift items)
    bindAddToCartIntercept(card);
    // Bind the checkout button intercept (ensures discount carries to checkout URL)
    bindCheckoutIntercept();
  }

  // Product IDs (from snippet/function) — used for cart watchdog
  var QUALIFYING_PRODUCT_IDS = [
    7707248656472, // Goodnight Mouth Tape
    7932686991448, // Mouth Tape - Pink
    8359715700824, // Collagen Mouth Tape
    7707250557016, // Nose Strips
    7932686696536, // Nose Strips - Pink
    15403174264920, // Collagen Mouth Tape + Face Tape Duo
    15501534724184 // Goodnight Deep Sleep Duo
  ];
  var GIFT_PRODUCT_IDS = [
    8040458190936, // Storage Tin
    8482214379608  // Tongue Cleaner
  ];

  // Cached cart snapshot, refreshed on cart events
  var __cartCache = { items: [] };
  var __cartFetchInflight = null;

  function refreshCartCache() {
    if (__cartFetchInflight) return __cartFetchInflight;
    __cartFetchInflight = (window.__gnt_original_fetch || window.fetch).call(window, '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { __cartCache = cart || { items: [] }; __cartFetchInflight = null; return __cartCache; })
      .catch(function () { __cartFetchInflight = null; });
    return __cartFetchInflight;
  }

  // Variant IDs that qualify for Tongue Cleaner (3mo + 6mo across all mouth tape + nose strips products)
  var TONGUE_CLEANER_QUALIFYING_VARIANT_IDS = [
    // Mouth tape 3mo + 6mo
    41932026806360, 41932026839128,
    // Pink mouth tape 3mo + 6mo
    42024174256216, 42024174288984,
    // Collagen Original 3mo + 6mo
    42848325795928, 42848325828696,
    // Collagen Vented 3mo + 6mo
    44484147904600, 44484147937368,
    // Nose strips 3mo + 6mo
    42040892948568, 42040892981336,
    // Pink nose strips 3mo + 6mo
    42040896127064, 42040896159832,
    // Duo 3mo
    67604044808280,
    // Beauty Sleep Duo 6mo
    68058606665816,
    // Deep Sleep Duo 3mo + 6mo
    68058623869016, 68058623901784
  ];

  var STORAGE_TIN_PRODUCT_ID = 8040458190936;
  var TONGUE_CLEANER_PRODUCT_ID = 8482214379608;

  function isGiftLine(item) {
    if (!item) return false;
    if (item.properties && item.properties._wk_gift) return true;
    return GIFT_PRODUCT_IDS.indexOf(item.product_id) !== -1;
  }
  function isStorageTinLine(item) {
    return item && item.product_id === STORAGE_TIN_PRODUCT_ID;
  }
  function isTongueCleanerLine(item) {
    return item && item.product_id === TONGUE_CLEANER_PRODUCT_ID;
  }
  function isQualifyingSubLine(item) {
    if (!item || !item.selling_plan_allocation) return false;
    return QUALIFYING_PRODUCT_IDS.indexOf(item.product_id) !== -1;
  }
  function isTongueCleanerQualifyingSubLine(item) {
    if (!item || !item.selling_plan_allocation) return false;
    var vid = item.variant_id || item.id;
    return TONGUE_CLEANER_QUALIFYING_VARIANT_IDS.indexOf(vid) !== -1;
  }
  function cartHasGiftProduct(productId) {
    if (__cartCache.items.some(function (it) { return it.product_id === productId; })) return true;
    // Optimistic flag — set the moment we add a gift to a cart-add payload, before the response comes back
    if (productId === 8040458190936 && __optimisticGifts.storageTin) return true;
    if (productId === 8482214379608 && __optimisticGifts.tongueCleaner) return true;
    return false;
  }

  var __optimisticGifts = { storageTin: false, tongueCleaner: false };

  function clearOptimisticGifts() { __optimisticGifts = { storageTin: false, tongueCleaner: false }; }

  // Watchdog: when no qualifying sub remains in cart, remove orphaned gift lines
  function ensureGiftsMatchCart() {
    return refreshCartCache().then(function () {
      // Sync optimistic flags with actual cart state
      __optimisticGifts.storageTin = __cartCache.items.some(function (it) { return it.product_id === STORAGE_TIN_PRODUCT_ID; });
      __optimisticGifts.tongueCleaner = __cartCache.items.some(function (it) { return it.product_id === TONGUE_CLEANER_PRODUCT_ID; });

      var hasAnySub = __cartCache.items.some(isQualifyingSubLine);
      var hasTongueQualifyingSub = __cartCache.items.some(isTongueCleanerQualifyingSubLine);

      // Decide what to remove
      var keysToRemove = [];
      __cartCache.items.forEach(function (item) {
        if (isStorageTinLine(item) && !hasAnySub) {
          keysToRemove.push(item.key);
        } else if (isTongueCleanerLine(item) && !hasTongueQualifyingSub) {
          keysToRemove.push(item.key);
        }
      });

      if (!keysToRemove.length) return;

      var origFetch = window.__gnt_original_fetch || window.fetch;
      return keysToRemove.reduce(function (p, key) {
        return p.then(function () {
          return origFetch.call(window, '/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
            credentials: 'same-origin'
          });
        });
      }, Promise.resolve())
        .then(refreshCartCache)
        .then(function () {
          // Re-sync optimistic flags from the now-updated cart
          __optimisticGifts.storageTin = __cartCache.items.some(function (it) { return it.product_id === STORAGE_TIN_PRODUCT_ID; });
          __optimisticGifts.tongueCleaner = __cartCache.items.some(function (it) { return it.product_id === TONGUE_CLEANER_PRODUCT_ID; });
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
    });
  }

  ['cart:refresh', 'cart:updated', 'cart:item-removed', 'cart:item-added'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(ensureGiftsMatchCart, 150); });
  });

  // Polling safety net. Was every 2s (two /cart.js reads each) for Corner Cart / Cartbot, which
  // changed the cart silently. The GNT cart drawer announces every change (cart:updated / the
  // fetch patch below), so this is now a rare backstop: every 15s, only while the tab is visible.
  // (ensureGiftsMatchCart already refreshes the cart cache itself.)
  setInterval(function () {
    if (document.visibilityState === 'visible') ensureGiftsMatchCart();
  }, 15000);

  // GLOBAL fetch interceptor — catches ALL /cart/add.js calls (mine, theme, apps, any).
  // If items array has a variant whose card has Subscribe selected, force-attach the matching
  // selling_plan. This is the nuclear safety net for mobile / Corner Cart / Cartbot collisions.
  (function patchFetch() {
    if (window.__gnt_wk_fetch_patched) return;
    window.__gnt_wk_fetch_patched = true;
    var origFetch = window.fetch;
    if (!origFetch) return;
    window.__gnt_original_fetch = origFetch; // expose for watchdog

    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (url && url.indexOf('/cart/add') !== -1 && init && init.body) {
          var bodyStr = typeof init.body === 'string' ? init.body : null;
          if (bodyStr) {
            var parsed;
            try { parsed = JSON.parse(bodyStr); } catch (e) { parsed = null; }
            if (parsed && parsed.items && Array.isArray(parsed.items)) {
              var changed = false;
              var giftsToAdd = []; // accumulate gift items to push after iteration

              parsed.items.forEach(function (item) {
                if (!item) return;
                var vid = parseInt(item.id, 10);
                if (!vid) return;

                // Find which card+tier this variant belongs to (across all kit cards)
                var cards = document.querySelectorAll('[data-gnt-wk-card]');
                for (var c = 0; c < cards.length; c++) {
                  var card = cards[c];
                  var sub = card.querySelector('input[name="gnt-wk-mode"][value="subscribe"]:checked');
                  if (!sub) continue;
                  // Determine tier from the ADDED variant's OWN title (style-agnostic:
                  // works for Original or Vented). Previously matched a single hardcoded
                  // data-variant-<tier> slot, which broke once each tier had 2 variants.
                  var dataNode = card.querySelector('[data-gnt-wk-variants]');
                  if (!dataNode) continue;
                  var cardVariants;
                  try { cardVariants = JSON.parse(dataNode.textContent); } catch (e) { continue; }
                  var matched = null;
                  for (var k = 0; k < cardVariants.length; k++) {
                    if (cardVariants[k].id === vid) { matched = cardVariants[k]; break; }
                  }
                  if (!matched) continue; // this variant isn't from this card
                  var tier = detectTier(matched.title, card);

                  // Attach selling_plan if not set — prefer the variant's own allocation.
                  if (!item.selling_plan) {
                    var spa = (matched.selling_plan_allocations || [])[0];
                    if (spa && spa.selling_plan_id) {
                      item.selling_plan = spa.selling_plan_id;
                      changed = true;
                    } else {
                      var attrPlan = parseInt(card.getAttribute('data-plan-' + tier) || '0', 10);
                      if (attrPlan) { item.selling_plan = attrPlan; changed = true; }
                    }
                  }

                  // Add gifts (Storage Tin for 1/3/6mo, Tongue Cleaner for 3/6mo)
                  var stId = card.getAttribute('data-gift-storage-tin');
                  var tcId = card.getAttribute('data-gift-tongue-cleaner');
                  var alreadyHasIds = {};
                  parsed.items.forEach(function (it) { if (it && it.id) alreadyHasIds[String(it.id)] = true; });
                  giftsToAdd.forEach(function (it) { if (it && it.id) alreadyHasIds[String(it.id)] = true; });

                  if (stId && !alreadyHasIds[String(stId)] && !cartHasGiftProduct(8040458190936) && (tier === '1mo' || tier === '3mo' || tier === '6mo')) {
                    giftsToAdd.push({ id: parseInt(stId, 10), quantity: 1, properties: { _wk_gift: 'yes' } });
                    __optimisticGifts.storageTin = true;
                    changed = true;
                  }
                  if (tcId && !alreadyHasIds[String(tcId)] && !cartHasGiftProduct(8482214379608) && (tier === '3mo' || tier === '6mo')) {
                    giftsToAdd.push({ id: parseInt(tcId, 10), quantity: 1, properties: { _wk_gift: 'yes' } });
                    __optimisticGifts.tongueCleaner = true;
                    changed = true;
                  }
                }
              });

              if (giftsToAdd.length) {
                parsed.items = parsed.items.concat(giftsToAdd);
              }
              if (changed) {
                init.body = JSON.stringify(parsed);
              }
            }
          }
        }
      } catch (e) { /* swallow */ }

      var resPromise = origFetch.apply(this, arguments);

      // After ANY cart-modifying call, refresh cache + run watchdog
      try {
        var urlStr = typeof input === 'string' ? input : (input && input.url) || '';
        if (urlStr && (
          urlStr.indexOf('/cart/add') !== -1 ||
          urlStr.indexOf('/cart/change') !== -1 ||
          urlStr.indexOf('/cart/update') !== -1 ||
          urlStr.indexOf('/cart/clear') !== -1
        )) {
          resPromise = resPromise.then(function (r) {
            setTimeout(function () {
              refreshCartCache().then(ensureGiftsMatchCart);
            }, 100);
            return r;
          });
        }
      } catch (e) { /* swallow */ }

      return resPromise;
    };
  })();

  function init() {
    document.querySelectorAll('[data-gnt-wk-card]').forEach(initCard);
    // Prime the cart cache + run the gift watchdog once on load
    refreshCartCache().then(ensureGiftsMatchCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
